'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, Input, Typography } from '@mui/material';
import { fieldName } from '../utils';
import { Logger } from '../../../lib/logger';
import RadioButtons from '../RadioButtons';
import SelectField from './SelectField';
import TextField from './TextField';
export default function Field({ type = 'text', name, label, labelVariant = 'default', context, sx = {}, required, value: inputValue = '', defaultValue = inputValue, validate = (value) => true, errorText = 'Invalid value', options = [], selectValueAttribute = 'value', selectLabelAttribute = 'label', defaultOptionLabel, loading, fullWidth = true, ...rest }) {
    const [error, setError] = useState('');
    const _formattedFieldName = useMemo(() => {
        Logger.log('_formattedFieldName', name);
        return Array.isArray(name) ? fieldName.apply(null, name) : name;
    }, [name]);
    const wrap = (children) => (_jsxs(Box, { sx: sx.root, children: [label && _jsx(Typography, { variant: "h6", children: label }), children] }));
    const handleBlur = ({ target }) => {
        !validate(target.value) && setError(errorText);
    };
    const handleFocus = (event) => {
        error && setError('');
    };
    const helperText = error ? error : rest.helperText;
    const isWrapped = label && labelVariant === 'detached';
    const fieldProps = {
        name: _formattedFieldName,
        required,
        defaultValue: inputValue,
        sx: sx.field,
        loading
    };
    !isWrapped && Object.assign(fieldProps, { label });
    const renderSelectField = () => {
        const component = (_jsx(SelectField, { options: options, ...fieldProps, label: label, defaultOptionLabel: defaultOptionLabel, selectLabelAttribute: selectLabelAttribute, selectValueAttribute: selectValueAttribute, ...rest, sx: { width: '100%' } }));
        if (isWrapped) {
            return wrap(component);
        }
        return component;
    };
    const renderRadioField = () => {
        const component = _jsx(RadioButtons, { items: options, ...fieldProps, ...rest });
        if (isWrapped) {
            wrap(component);
        }
        return component;
    };
    const renderTextField = () => {
        const component = (_jsx(TextField, { type: type, onBlur: handleBlur, onFocus: handleFocus, helperText: helperText, fullWidth: fullWidth, error: Boolean(error), ...fieldProps, ...rest }));
        if (isWrapped) {
            return wrap(component);
        }
        return component;
    };
    const renderHiddenField = () => (_jsx(Input, { type: "hidden", name: _formattedFieldName, defaultValue: defaultValue }));
    const renderField = (fieldType) => {
        switch (fieldType) {
            case 'hidden':
                return renderHiddenField();
            case 'radio':
                return renderRadioField();
            case 'select':
                return renderSelectField();
            default:
                return renderTextField();
        }
    };
    return _jsx(_Fragment, { children: renderField(type) });
}
